/**
 * @file paddle pilot sailing
 * @author wanzhongyun
 */

import React, { useState } from 'react';
import { Carousel, Tabs } from 'antd';
import { IPilotSailing } from './../../type';

import './style.less';
import classNames from 'classnames';


const PilotSailing: React.FC<IPilotSailing> = props => {

    const { TabPane } = Tabs;
    const { title, bannerList, excitingActivities, excitingProject } = props;

    const [currrentActivity, setCurrentActivity] = useState<number>(0);

    const handleCarouselChange = (currentSlide: number) => {
        setCurrentActivity(currentSlide);
    };

    return (
        <div className='paddle-pilot-sailing-wrapper'>
            <div id='startSailing' className='paddle-pilot-anchor' />
            <div className='paddle-pilot-sailing-title'>{ title }</div>
            <div className='paddle-pilot-sailing-content-wrapper'>
                <div className='paddle-pilot-sailing-content-banner'>
                    <Carousel effect="fade" autoplay afterChange={handleCarouselChange}>
                        {
                            bannerList.map(item => <div className="banner-card" key={item.title + item.time}>
                                    <a href={item.targetLink} target='_blank' rel="noreferrer">
                                        <img className="banner-card-image" src={item.backgroundImageUrl}  alt={item.title} />
                                    </a>
                                    <div className='banner-card-mask'>
                                        <div className='banner-card-time'>{ item.time }</div>
                                        <div className='banner-card-title'>{ item.title }</div>
                                    </div>
                            </div>)
                        }
                    </Carousel>
                </div>

                <div className='paddle-pilot-activity-project'>
                    <Tabs defaultActiveKey="activity">
                        <TabPane tab={excitingActivities.title} key="activity">
                            {
                                excitingActivities.list.map((item, index) => <div className={classNames('paddle-pilot-activity-item', {'check-option': index === currrentActivity})} key={item.title}>
                                    <div className='activity-item-title'>
                                        <a href={item.link} target='_blank' rel='noreferrer'>{ item.title }</a>
                                    </div>
                                    <div className='activity-item-time'>{ item.activityTime }</div>
                                </div>)
                            }
                        </TabPane>
                        
                        <TabPane tab={excitingProject.title} key="project">
                            {
                                excitingProject.list.map(item => <div className='paddle-pilot-activity-item' key={item.title}>
                                    <div className='activity-item-title'>
                                        <a href={item.link} target='_blank' rel='noreferrer'>{ item.title }</a>
                                    </div>
                                    <div className='activity-item-time'>{ item.projectTime }</div>
                                </div>)
                            }
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        </div>
    );
};

export default PilotSailing;